(function () {
    'use strict';

    angular.module('app.tasks', [
        'app.core',
        'app.widgets'
    ]);
})();
